import React, { useEffect } from 'react'

import OpenBox from '@icons/OpenBox.jsx'
import SwimHat from '@icons/SwimHat.jsx'
import Tag from '@icons/Tag.jsx'
import FreeGift from '@icons/FreeGift.jsx'
import EmbroideredBlanket from '@icons/EmbroideredBlanket.jsx'
import useWindowDimensions from '@hooks/useWindowDimensions.js'

const invalidProductTypes = [
    'Gift Cards',
    'Gift Card',
    'Specialty SKU',
    'Embroidery Option',
    'Embroidery',
    'Virtual Classes',
    'Classes + Events',
    'Nursery',
    'Cribs',
    'Classes',
    'Strollers',
]

const swimProductTypes = ['Swim Coverups', 'Swimwear', 'Sun Hats']

let pathname
let isProductPage = false

const Flags = ({
    currentProduct,
    currentProductTags,
    tagObject,
    productHandle,
    currentVariantId,
    currentBaseUrl,
}) => {
    useEffect(() => {
        pathname = window.location.pathname

        //

        if (pathname.includes('/products/')) {
            isProductPage = true
        }
    }, [])

    //
    //
    const { windowWidth, windowHeight } = useWindowDimensions()

    // useEffect(() => {
    //     currentBaseUrl = window.location.origin
    //     //
    // }, [window.location.origin])

    const productType = currentProduct?.product_type

    if (productType && invalidProductTypes.includes(productType)) {
        return
    }

    let offerTags = Object.keys(tagObject)
        .map((item) => {
            if (currentProductTags && currentProductTags.includes(item)) {
                return tagObject[item]
            }
        })
        .filter((x) => x !== undefined)

    //

    const vendor = currentProduct?.vendor || 'Monica + Andy'

    let isGet30Off = false
    let isGet40Off = false
    let isGet50Off = false
    let isGet60Off = false
    let is20Off = false
    let is30Off = false
    let is25Off = false
    let is40Off = false
    let is40Sale = false
    let is50Off = false
    let isBuy2Get25 = false
    let isBuy3Get30 = false
    let isBuy3Get35 = false
    let isDisney = false

    let isFreeEmbroidery = false
    let isEmbroidery = false

    let isFreeShipping = false
    let isDoorbuster = false
    let isMAFreeGiftCard = false

    let isSpring2025 = false

    // Check if the product is on sale and calculate actual discount
    let isOnSale = false
    let discountPercent = 0

    // Check for SALE in product title (these get additional 40% off)
    const isSaleProduct = currentProduct?.title && currentProduct.title.includes('SALE');

    // Check if product has a compare_at_price that's higher than the current price
    if (currentProduct?.compare_at_price_max && currentProduct?.price_max &&
        currentProduct.compare_at_price_max > currentProduct.price_max) {
        isOnSale = true

        const compareAtPrice = currentProduct.compare_at_price_max;
        const currentPrice = currentProduct.price_max;

        if (isSaleProduct) {
            // For SALE products, apply additional 40% off the already discounted price
            const additionalDiscountPrice = currentPrice * 0.6;

            // Calculate total discount from original compare-at price
            const totalDiscountAmount = compareAtPrice - additionalDiscountPrice;
            discountPercent = Math.round((totalDiscountAmount / compareAtPrice) * 100);
        } else {
            // For regular discounted products, calculate discount normally
            const discountAmount = compareAtPrice - currentPrice;
            discountPercent = Math.round((discountAmount / compareAtPrice) * 100);
        }
    }

    if (
        vendor === 'Monica + Andy' &&
        currentProductTags?.includes('embroidery2023') &&
        !currentProductTags?.includes('matchingfamilypjs')
    ) {
        isEmbroidery = true
    }

    if (vendor === 'Monica + Andy' && currentProductTags?.includes('disney')) {
        isDisney = true
    } else if (
        vendor === 'Monica + Andy' &&
        !currentProductTags?.includes('disney')
    ) {
        isDisney = false
    }

    if (vendor === 'Monica + Andy' && !isDisney && !isOnSale) {
        is40Off = true
    }

    // if (
    //     vendor === 'Monica + Andy' &&
    //     currentProductTags?.includes('embroidery2023') &&
    //     !currentProductTags?.includes('matchingfamilypjs')
    // ) {
    //     isFreeEmbroidery = true
    // }

    // if (currentProductTags?.includes('buy2get25')) {
    //     isBuy2Get25 = true
    // }

    // if (currentProductTags?.includes('buy3get30')) {
    //     isBuy3Get30 = true
    // }

    // if (currentProductTags?.includes('buy3get35')) {
    //     isBuy3Get35 = true
    // }

    // if (currentProductTags?.includes('doorbuster2024')) {
    //     isDoorbuster = true
    // }

    // if (vendor === 'Monica + Andy') {
    //     isFreeShipping = true
    //     isMAFreeGiftCard = true
    // }

    // if (
    //     vendor === 'Monica + Andy' &&
    //     !currentProductTags?.includes('disneyprincess2024') &&
    //     !currentProductTags?.includes('winterdisneyprincess2024') &&
    //     !currentProductTags?.includes('toy-story') &&
    //     !currentProductTags?.includes('wintertoystory2024')
    // ) {
    //     is50Off = true
    // }

    // if (currentProductTags?.includes('spring2025')) {
    //     isSpring2025 = true
    // }

    // if (vendor === 'Monica + Andy') {
    //     if (currentProductTags?.includes('swim2024') || currentProductTags?.includes('springbreakshop2024') || currentProductTags?.includes('skibreak2024') || currentProductTags?.includes('Disney100')) {
    //         is30Off = true
    //     } else {
    //         is30Off = false
    //     }
    // }

    // if (vendor === 'Monica + Andy') {
    //     if (currentProductTags?.includes('fallhalloween2024')) {
    //         is30Off = true
    //     } else {
    //         is30Off = false
    //     }
    // }

    // if (vendor === 'Monica + Andy') {
    //     if (
    //         !currentProductTags?.includes('halloween') &&
    //         !currentProductTags?.includes('fallhalloween2024')
    //     ) {
    //         is40Off = true
    //     } else {
    //         is40Off = false
    //     }
    // }

    // if (vendor === 'Monica + Andy') {
    //     if (currentProduct?.title.includes('SALE')) {
    //         is20Off = true
    //     } else {
    //         is20Off = false
    //     }
    // }

    // if (vendor === 'Monica + Andy') {
    //     is40Off = true
    // }

    // if (vendor === 'Monica + Andy') {
    //     if (currentProduct?.title.includes('SALE')) {
    //         is40Sale = true
    //     } else {
    //         is40Off = true
    //     }
    // }

    // if (vendor === 'Monica + Andy') {
    // 	if (swimProductTypes.includes(currentProduct?.product_type)) {
    // 		is40Off = true
    // 	} else {
    // 		is40Off = false
    // 	}
    // }

    // if (vendor === 'Monica + Andy' && currentProductTags?.includes('Baby Pajamas') || currentProductTags?.includes('Adult Pajamas') || currentProductTags?.includes('Toddler/Kid Pajamas')) {
    //     isGet30Off = true
    // }

    // if (
    //     vendor === 'Monica + Andy' &&
    //     currentProductTags?.includes('40offsummersale2024')
    // ) {
    //     is40Off = true
    // }

    //

    const handleFlagClick = (e) => {
        e.preventDefault()
        const flagsWrap = e.target.closest('.flags-wrap')
        const href = flagsWrap.getAttribute('data-href')
        if (windowWidth < 768) {
            setTimeout(() => {
                location.replace(href)
            }, 100)
        }
    }

    return (
        <div className="product-flags-outer">
            <div
                className={`product-flags-inner mt-auto flex flex-wrap relative ${
                    isProductPage ? 'gap-x-1' : 'gap-x-2 gap-y-1'
                }`}
            >
                {/* {offerTags.length > 0 &&
                    offerTags.map((tag, i) => {
                        return (
                            <div
                                className="mt-auto px-1 py-0 border border-slate font-light text-xs text-flint inline-flex items-center flex-0 bg-beige"
                                key={tag + '-' + i}
                            >
                                <div className="tag-icon mr-2">
                                    {tag === 'UPF 50' ? (
                                        <SwimHat width="w-[12px]" />
                                    ) : tag !== '30% Off In Cart' ? (
                                        <OpenBox width="w-[12px]" />
                                    ) : (
                                        <Tag width="w-[12px]" />
                                    )}
                                </div>
                                <span className="text-[11px]">{tag}</span>
                            </div>
                        )
                    })} */}
                {/* {isGet30Off && (
                <div className="px-2 py-1 border border-slate font-light text-xs inline-flex items-center flex-0 bg-sun">
                    <div className="tag-icon mr-2">
                        <Tag width="w-[18px]" />
                    </div>
                    30% Off In Cart
                </div>
            )} */}
                {/* {isGet40Off && (
                <div className="mt-auto px-1 py-0 border border-slate font-light text-xs inline-flex items-center flex-0 bg-sun">
                    <div className="tag-icon mr-2">
                        <Tag width="w-[12px]" />
                    </div>
                    <span className="text-[11px]">40% Off In Cart</span>
                </div>
            )} */}
                {/* {isGet60Off && (
                <div className="px-2 py-1 border border-slate font-light text-xs inline-flex items-center flex-0 bg-sun">
                    <div className="tag-icon mr-2">
                        <Tag width="w-[18px]" />
                    </div>
                    60% Off In Cart
                </div>
            )} */}
                {/* {isDoorbuster && isProductPage && (
                    <div className="px-2 border border-[#E24B52] font-light text-xs inline-flex items-center flex-0 bg-[#E24B52] text-white">

                        Doorbuster
                    </div>
                )} */}
                {isEmbroidery && isProductPage && (
                    <div
                        className={`mt-auto px-1 py-0 border border-slate font-light text-xs inline-flex items-center flex-0 bg-white text-flint ${
                            isProductPage ? '' : 'absolute bottom-4 -left-[1px]'
                        }`}
                    >
                        <div className="tag-icon mr-2">
                            <EmbroideredBlanket width="w-[12px]" />
                        </div>
                        <span className="text-[11px]">Personalize It!</span>
                    </div>
                )}
                {/* {isFreeEmbroidery && isProductPage && (
                    <div
                        className={`mt-auto px-1 py-0 border border-slate font-light text-xs inline-flex items-center flex-0 bg-corn text-flint ${
                            isProductPage ? '' : 'absolute bottom-4 -left-[1px]'
                        }`}
                    >
                        <div className="tag-icon mr-2">
                            <EmbroideredBlanket width="w-[12px]" />
                        </div>
                        <span className="text-[11px]">Free Embroidery!</span>
                    </div>
                )} */}
                {/* {is20Off && (
                    <div className="mt-auto px-1 py-0 border border-slate font-light text-[12px] inline-flex items-center flex-0 bg-carrot/60 min-w-[150px]">
                        <div className="tag-icon mr-[5px]">
                            <Tag width="w-[13px]" />
                        </div>
                        Extra 20% Off Applied!
                    </div>
                )} */}

                {is40Off && (
                    <div className="mt-auto px-1 py-0 text-xs border border-slate font-light inline-flex items-center flex-0 bg-carrot/60 min-w-[150px]">
                        <div className="tag-icon mr-[5px]">
                            <Tag width="w-[13px]" />
                        </div>
                        <span className="text-[11px]">40% Off Extended!</span>
                    </div>
                )}
                {/*}{is40Sale && (
                    <div className="mt-auto px-1 py-0 text-xs border border-slate font-light inline-flex items-center flex-0 bg-carrot/60 min-w-[150px]">
                        <div className="tag-icon mr-[5px]">
                            <Tag width="w-[13px]" />
                        </div>
                        <span className="text-[11px]">
                            40% Off ENDS MONDAY!
                        </span>
                    </div>
                )} */}
                {/* {is40Off && (
                    <div className='mt-auto px-1 py-0 border border-slate font-light text-[12px] inline-flex items-center flex-0 bg-sun/60'>
                        <div className='tag-icon mr-[5px]'>
                            <Tag width='w-[13px]' />
                        </div>
                        <span className='text-[11px]'>
                            Final Day: 40% Off!
                        </span>
                    </div>
                )} */}
                {!isDisney && (isSaleProduct || isOnSale) && (
                    <div className='mt-auto px-1 py-0 border border-slate font-light text-[12px] inline-flex items-center flex-0 bg-sun/60'>
                        <div className='tag-icon mr-[5px]'>
                            <Tag width='w-[13px]' />
                        </div>
                        <span className='text-[11px]'>
                            40% off already applied!
                        </span>
                    </div>
                )}
                {/* {is50Off && (
                    <div className='mt-auto px-1 py-0 border border-slate font-light text-xs text-flint inline-flex items-center flex-0 bg-beige'>
                        <span className='text-[11px]'>50% Off ends today!</span>
                    </div>
                )} */}
                {/* {isFreeShipping && (
                    <div className='mt-auto px-1 py-0 border border-slate font-light text-xs text-flint inline-flex items-center flex-0 bg-beige'>
                        <span className='text-[11px]'>Free Shipping on $50+</span>
                    </div>
                )} */}
                {/* {isFreeShipping && (
                    <div className='mt-auto px-1 py-0 border border-slate font-light text-xs text-flint inline-flex items-center flex-0 bg-beige'>
                        <span className='text-[11px]'>Spend $75, get $20!</span>
                    </div>
                )} */}
                {/* {isFreeEmbroidery && !isProductPage && (
                    <div
                    className={`mt-auto px-1 py-0 border border-slate font-light text-xs text-flint inline-flex items-center flex-0 bg-beige`}
                >
                    <div className="tag-icon mr-2">
                        <EmbroideredBlanket width="w-[12px]" />
                    </div>
                    <span className="text-[11px]">Free Embroidery!</span>
                </div>
                )} */}
                {/* {isSpring2025 && (
                    <div className='mt-auto px-1 py-0 border border-slate font-light text-xs text-flint inline-flex items-center flex-0 bg-beige'>
                        <span className='text-[11px]'>NEW</span>
                    </div>
                )} */}
            </div>
        </div>
    )
}

export default Flags
